// extracted by mini-css-extract-plugin
export default {"pageShell":"AdminGroupInvoices_pageShell__nlIKN"};